import immer, { setAutoFreeze } from 'immer'
import _ from 'lodash'

import { genFullListName, isEqualWithType } from './index'

setAutoFreeze(false)

/**
 * 
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} fieldName 
 */
export const getInitValue = (that, fieldsetName = '', fieldName) => {
	return (that && { ...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`] } || {})[fieldName]
}

/**
 * 不处理listValues，如为listValues则返回应该为undefined 
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} fieldName 
 */
export const getChangedValue = (that, fieldsetName = '', fieldName) => {
	return (that && that[`changedValues${fieldsetName}`] || {})[fieldName]
}

/**
 * 
 * 取所有的changedValues或指定的changedValues(如果fieldsetName为字符串)，
 * 如要that.props.id !== undefine && !== null，包含id
 * 如果needInit=true || needInit != false && that.props.id === 0，还包含id及所有的initValues或指定的initValues(如果fieldsetName为字符串)
 * 返回结果形如:{id:, changedValues基本信息:{...}, initValues基本信息:{...}}
 * 注意: 请勿修改返回的changedValuesXXX, initValuesXXX内的数组及对象内容
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} needInit 
 */
export const getChangedFieldsets = (that, fieldsetName = null, needInit = null) => {
	const ret = {}
	if (!that || !that.props || !that.state) {
		console.error('参数错误')
		return ret
	}

	// 取id
	const { id } = { ...that.props || {}, ...that.state }
	true && (id != undefined && id != null) && (ret.id = id)

	// 取changedValues
	typeof fieldsetName === 'string'
		? ret[`changedValues${fieldsetName}`] = { ...that.state[`changedValues${fieldsetName}`] }
		: Object.entries(that.state).filter(([key]) => key.startsWith('changedValues')).forEach(([key, values]) => ret[key] = { ...values })
	// 取initValues
	true && (needInit || (needInit != false && id === 0)) && (
		typeof fieldsetName === 'string'
			? ret[`initValues${fieldsetName}`] = { ...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`] }
			: (
				Object.entries(that.props).filter(([key]) => key.startsWith('initValues')).forEach(([key, values]) => ret[key] = { ...values }),
				Object.entries(that.state).filter(([key]) => key.startsWith('initValues')).forEach(([key, values]) => ret[key] = { ...ret[key], ...values })
			)
	)

	return ret
}


/**
 * 取一个field的值
 * @param {Object} that 
 * @param {String} fieldsetName 
 * @param {String} fieldName 
 * @param {{listName:String, id:int}} list default: undefined  形如 {listName:'xxx', id:10}，即取listName项下id为10的列表数据中的fieldName的值
 */
export const getFormValue = (that, fieldsetName = '', fieldName, list) => {
	fieldName = genFullListName(list, fieldName)

	let { [`${fieldName}`]: val, [`${fieldName}-added`]: added, [`${fieldName}-deleted`]: deleted } = {
		...(that && {
			...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`],
			...that.state[`changedValues${fieldsetName}`]
		})
	}
	val = (added || deleted) && !val ? [] : val
	val = Array.isArray(val) ? [...val] : val

	for (const o of added ?? []) !val.includes(o) && val.push(o)
	for (const o of deleted ?? []) val.includes(o) && val.splice(val.indexOf(o), 1)

	return val
}

export const setItemInitValuesAsync = (...args) => {
	return Promise.resolve().then(() => {
		setItemInitValues(args)
		return
	})
}


export const setItemInitValues = (that, fieldsetName = '', itemNamesPar, initValuesPar) => {
	if (!that || (!fieldsetName && fieldsetName !== '') || !itemNamesPar) {
		console.log('setItemValues: 有参数为空')
		return
	}

	if (Array.isArray(itemNamesPar) && !Array.isArray(initValuesPar)) {
		console.log('setItemValues: itemNamesPar 与 initValuesPar不匹配')
		return
	}

	const itemNamesArr = Array.isArray(itemNamesPar) ? itemNamesPar : [itemNamesPar]
	const initValuesArr = Array.isArray(itemNamesPar) ? initValuesPar : [initValuesPar]

	that && that.setState(immer(draft => {
		const initValues = draft[`initValues${fieldsetName}`] ? draft[`initValues${fieldsetName}`] : (draft[`initValues${fieldsetName}`] = {})

		itemNamesArr.forEach((name, index) => {
			initValues[name] = initValuesArr[index]
		})
	}))
}

export const changeItemsValueAsync = (...args) => {
	return Promise.resolve().then(() => {
		changeItemsValue(args)
		return
	})
}

// export const getInitValues = (that, fieldsetName) => that && { ...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`] } || {}

export const changeItemsValue = (that, fieldsetName = '', itemNamesPar, changedValuesPar, typesOfchangedValuesPar) => {
	if (!that || (!fieldsetName && fieldsetName !== '') || !itemNamesPar) {
		console.error('changeItemsValue: 有参数为空')
		return false
	}

	if (Array.isArray(itemNamesPar) && !Array.isArray(changedValuesPar)) {
		console.error('changeItemsValue: itemNamesPar 与 changeValuesPar不匹配')
		return false
	}

	const itemNamesArr = Array.isArray(itemNamesPar) ? itemNamesPar : [itemNamesPar]
	const changedValuesArr = Array.isArray(itemNamesPar) ? changedValuesPar : [changedValuesPar]

	if (itemNamesArr.length > changedValuesArr.length) {
		console.error('changedItemsValue: 值 列表长度小于 名称 列表长度')
		return false
	}

	let countChanged = 0

	that && that.setState((state, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...state[`initValues${fieldsetName}`] }
		const changedValues = { ...state[`changedValues${fieldsetName}`] }
		const values = { ...initValues, ...changedValues }
		const typesOfchangedValues = { ...state[`typesOfchangedValues${fieldsetName}`] }

		itemNamesArr.forEach((name, index) => {
			const type = Array.isArray(typesOfchangedValuesPar) && (typesOfchangedValuesPar[index] || 'string') || typesOfchangedValuesPar || 'string'
			const initValue = initValues[name]
			const oldValue = values[name]
			// 1. 新值 ：如果 输入值与初始值 一致，则取 初始值，否则 为输入值
			const newValue = isEqualWithType(initValue, changedValuesArr[index], type) ? initValue : changedValuesArr[index]
			// 2. 新值 与 旧值一致，不做改变
			if (isEqualWithType(newValue, oldValue, type)) return
			// 3. 新值 与 初始值 相同(因为1.中已经比较过) 则删除changedValues[name]，否则 置changedValues[name]
			newValue === initValue ? delete changedValues[name] : changedValues[name] = newValue
			type && (typesOfchangedValues[name] = type)
			countChanged++
		})
		return countChanged ? {
			[`changedValues${fieldsetName}`]: changedValues,
			[`typesOfchangedValues${fieldsetName}`]: typesOfchangedValues,
		} : null
	})

	return !!countChanged
}

// 检查是否有修改的值存在, fieldsetName为字符串时只检查指定的fileset
export const hasChangedValues = (that, fieldsetName = undefined) =>
	!!(that && that.state && (typeof fieldsetName === 'string'
		? Object.values(that.state[`changedValues${fieldsetName}`] || {}).length
		: Object.entries(that.state).find(([n, v]) => n.startsWith('changedValues') && Object.keys(v).length)))

export const getMergedValues = (that, fieldsetName = '') => {
	const values = JSON.parse(JSON.stringify(that && {
		...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`],
		...that.state[`changedValues${fieldsetName}`]
	}))

	// 删除所有field-changed
	Object.keys(values).filter(o => o.endsWith('-changed')).forEach(changedName => delete values[changedName])

	// 增加所有field-added到field
	Object.keys(values).filter(o => o.endsWith('-added')).forEach(addedName => {
		const fieldName = addedName.substring(0, addedName.length - 6)
		values[fieldName] = (values[fieldName] || []).concat(values[addedName])
		delete values[addedName]
	})

	// 删除所有field-deleted相关的field[id]数据及field中的id
	const deletedFieldPres = []
	Object.keys(values).filter(o => o.endsWith('-deleted')).forEach(deletedName => {
		const fieldName = deletedName.substring(0, deletedName.length - 8)
		const value = values[fieldName]
		const deleted = values[deletedName]
		if (!value || !deleted)
			return

		deleted.forEach(id => {
			// 删除id
			value.indexOf(id) >= 0 && value.splice(value.indexOf(id), 1)
			// 置deletedFieldPres
			deletedFieldPres.push(_.escapeRegExp(`${fieldName}[${id}]`))
		})
		!value.length && delete values[fieldName]

		// 删除-deleted
		delete values[deletedName]
	})
	// 删除field[id].*
	if (deletedFieldPres.length) {
		deletedFieldPres.sort()
		for (var i = 1; i < deletedFieldPres.length;)
			deletedFieldPres[i].startsWith(deletedFieldPres[i - 1]) ? deletedFieldPres.splice(i, 1) : i++
		const matchString = `^(${deletedFieldPres.join('|')})\\.(.+)`
		Object.keys(values).forEach(key => key.match(matchString) && delete values[key])
	}
	// _.escapeRegExp
	return values
}

/**
 * 清除changedValues, 如果fieldsetName == undefined 或 null，清空所有changedValues
 * @param {*} that 
 * @param {*} fieldsetName 
 */
export const clearFormChangedValues = (that, fieldsetName = undefined) => {
	that.setState(state => {
		if (fieldsetName != undefined && fieldsetName != null) {
			return { [`changedValues${fieldsetName}`]: {} }
		} else {
			const ret = {}
			Object.keys(state).forEach(name => name.startsWith('changedValues') && (ret[name] = {}))
			return ret
		}
	})
}